const storage = {
  local: {
    get: (key) => {
      const dataStr = window.localStorage.getItem(key);
      return dataStr && JSON.parse(dataStr);
    },
    set: (key, data) => {
      const dataStr = JSON.stringify(data);
      window.localStorage.setItem(key, dataStr);
    },
    remove: (key) => {
      window.localStorage.removeItem(key);
    },
  },
  session: {
    get: (key) => {
      const dataStr = window.sessionStorage.getItem(key);
      return dataStr && JSON.parse(dataStr);
    },
    set: (key, data) => {
      const dataStr = JSON.stringify(data);
      window.sessionStorage.setItem(key, dataStr);
    },
    remove: (key) => {
      window.sessionStorage.removeItem(key);
    },
  },
};
export default storage;
